import React, { FC } from "react";
import { SmartSearchItemDto } from "../../../Api/Model/SmartSearch/SmartSearchItemDto.csharp";

export const DoctorResultItem: FC<SmartSearchItemDto> = ({
  doctor,
  url,
  title,
}) => {
  return doctor ? (
    <div className="card card-hover mb-1">
      <div className="card-body">
        <div className="d-flex">
          <img
            className="circular-image medium me-2"
            src={
              doctor.pictureUrl +
              "?width=100&height=100&rmode=crop&ranchor=top"
            }
            alt=""
            loading="lazy"
          />
          <div className="lh-sm">
            <h2 className="h5 mb-0">
              <a href={url} className="card-block-link">
                {title}
              </a>
            </h2>
            <p className="fs-5 pt-2 mb-0">{doctor.jobTitle}</p>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
